<template>
  <div>
    <md-content>
      <viewer
        :content="false"
        :embed="true"
        :mode="mode"
        :nid="nuuid"
        :sid="suuid"
        :draft_sid="draft_suuid"
        field="field_set_form"
        :set-view-mode="setViewMode"
        @change-status="status = $event"
      />
    </md-content>
  </div>
</template>

<script>
import Viewer from "./Viewer.vue";
export default {
  name: "Set",
  props: ["mode", "nid", "sid", "set-view-mode"],
  created() {
    let self = this;
    let fieldName = "field_set_form";
    Object.keys(
      window.drupalSettings.form_builder[self.nuuid].submissions
    ).forEach(submission => {
      if (
        window.drupalSettings.form_builder[self.nuuid].submissions[submission]
          .template ==
        window.drupalSettings.form_builder[self.nuuid].tabs.field_set_form
          .template.uuid &&
        window.drupalSettings.form_builder[self.nuuid].submissions[
            submission
          ].section == fieldName
        && !window.drupalSettings.form_builder[this.nuuid].submissions[submission].isDraft
      ) {
        self.suuid = submission;
      }
      if (
        window.drupalSettings.form_builder[this.nuuid].submissions[submission]
          .template == window.drupalSettings.form_builder[this.nuuid].tabs.field_set_form.template.uuid &&
        window.drupalSettings.form_builder[self.nuuid].submissions[
            submission
          ].section == fieldName
        && window.drupalSettings.form_builder[this.nuuid].submissions[submission].isDraft == true
      ) {
        self.draft_suuid = submission;
      }
    });
  },
  activated() {
    if(!this.setViewMode && this.suuid != "" &&
      window.drupalSettings.form_builder[this.nuuid].submissions[this.suuid] &&
      !window.drupalSettings.form_builder[this.nuuid].submissions[this.suuid].isDraft) {
      this.status = window.drupalSettings.form_builder[this.nuuid].submissions[this.suuid].status;
      //this.$router.push("/strategy/" + this.id + "/set/thanks");
    }
    this.$emit('set-active');
    setTimeout(() => {
      window.H5P.init();
    }, 0);

  },
  data() {
    return {
      showNavigation: false,
      view_mode: this.mode || false,
      dev_mode: window.webpackHotUpdate,
      nuuid: this.nid || "",
      suuid: this.sid || "",
      draft_suuid: null,
      id: this.$route.params.id,
      status: ''
    };
  },
  components: {
    Viewer
  },
  watch: {
    status(newStatus) {
      this.$emit("change-status", newStatus);
    }
  },
};
</script>
